import type { PropsWithChildren } from 'react';
import dynamic from 'next/dynamic';
import type { MapProps } from 'shared/map/interfaces';

const DynamicMap = dynamic(() => import('shared/map/ClientSideMap'), {
    loading: () => <div className="map-placeholder" />,
    ssr: false,
});

export const HotelMap = (props: PropsWithChildren<MapProps>) => <DynamicMap {...props} />;
